module.exports = __webpack_public_path__ + "static-portal/img/icon-02.437e275.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeManage/module/icons/icon-02.png
// module id = /wrH
// module chunks = 4